import { render } from "./AddLangueModal.vue?vue&type=template&id=3efbe433&ts=true"
import script from "./AddLangueModal.vue?vue&type=script&lang=ts"
export * from "./AddLangueModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__